import React from 'react';
const ProductImageButton = (props) => {
    return (React.createElement("button", { className: "product-image-button", "aria-haspopup": "dialog", onClick: (e) => {
            //Prevent opening the zoom image when play/pause video
            if (!e.target.classList.contains('product-video-pause')) {
                //Prevent opening the zoom image when tapping on hotspots
                if (!e.target.closest('.spott-marker-box'))
                    props.onImageClick();
            }
        }, "aria-label": props.ariaLabel }, props.children));
};
export default ProductImageButton;
